import dayjs from 'dayjs'
import { useEffect } from 'react'

type Props = {
  startDate?: string | null
  endDate?: string | null
  updateSearchParams: (params: { startDate?: string; endDate?: string }) => void
  timeRange?: 'today' | 'yesterday' | 'last7days' | 'last30days'
}
export const useSetDefaultTimeRange = (props: Props) => {
  const {
    startDate,
    endDate,
    updateSearchParams,
    timeRange = 'yesterday',
  } = props
  const getStartDate = () => {
    const today = dayjs()
    switch (timeRange) {
      case 'today':
        return today.startOf('day')
      case 'yesterday':
        return today.subtract(1, 'day').startOf('day')
      case 'last7days':
        return today.subtract(6, 'day').startOf('day')
      case 'last30days':
        return today.subtract(29, 'day').startOf('day')
      default:
        return today.subtract(1, 'day').startOf('day')
    }
  }
  const getEndDate = () => {
    const today = dayjs()
    switch (timeRange) {
      case 'today':
        return today.endOf('day')
      case 'yesterday':
        return today.subtract(1, 'day').endOf('day')
      case 'last7days':
        return today.endOf('day')
      case 'last30days':
        return today.endOf('day')
      default:
        return today.endOf('day')
    }
  }
  useEffect(() => {
    const checkAndSetDefaultDateRange = () => {
      if (startDate && endDate) {
        return
      }
      const defaultStartDate = getStartDate()
      const defaultEndDate = getEndDate()
      updateSearchParams({
        startDate: defaultStartDate.format('YYYY-MM-DD'),
        endDate: defaultEndDate.format('YYYY-MM-DD'),
      })
    }
    checkAndSetDefaultDateRange()
  }, [startDate, endDate, updateSearchParams])
}
